import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/mainbanner.png'


const _hoisted_1 = { class: "main-banner" }
const _hoisted_2 = { class: "main-banner__inner" }
const _hoisted_3 = { class: "main-banner__left main-banner__item" }
const _hoisted_4 = { class: "main-banner__text" }
const _hoisted_5 = { class: "main-banner__title" }
const _hoisted_6 = { class: "main-banner__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('banner.title')), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('banner.subtitle')), 1)
        ])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "main-banner__right main-banner__item" }, [
        _createElementVNode("img", {
          class: "main-banner__img",
          src: _imports_0,
          alt: "banner"
        })
      ], -1))
    ])
  ]))
}